import { ISalePageDetailV2Response } from '@/api/types';
import {
  digitalBasic,
  digitalCustom,
  fundingSections,
  physicalCreatorGoodsNormal,
  physicalCreatorGoodsReserve,
  physicalVuddyOriginalNormal,
  physicalVuddyOriginalReserve,
} from './const';

export const getGuideSections = (
  salePage: Partial<ISalePageDetailV2Response>
) => {
  const isFunding = salePage.type === 'FUNDING';
  const isPhysical = salePage.type === 'PHYSICAL';
  const isDigital = salePage.type === 'DIGITAL';

  if (isFunding) {
    return fundingSections;
  }

  if (isPhysical) {
    if (salePage.physical?.detailType === 'CREATOR_GOODS') {
      if (salePage.physical.method === 'NORMAL') {
        return physicalCreatorGoodsNormal;
      } else if (salePage.physical.method === 'RESERVATION') {
        return physicalCreatorGoodsReserve;
      }
    }

    if (salePage.physical?.detailType === 'VUDDY_ORIGINAL') {
      if (salePage.physical.method === 'NORMAL') {
        return physicalVuddyOriginalNormal;
      } else if (salePage.physical.method === 'RESERVATION') {
        return physicalVuddyOriginalReserve;
      }
    }
  }

  if (isDigital) {
    if (salePage.hasCustomMediaProducts) {
      return digitalCustom;
    } else {
      return digitalBasic;
    }
  }

  return null;
};
